
import totp_setup from './totp-setup.js';

export default [ totp_setup ];

